<form
  [formGroup]="signin_form_group"
  class="sp-row__space sp-wrap sp-form__standalone sp-padding__x4">
  <h2 class="sp-color__accent-contrast sp-margin__bottom">
    {{ 'AUTH.SIGNIN_TITLE' | translate }}
  </h2>
  <p class="sp-color__accent-contrast sp-margin__bottom-x4">
    {{ 'AUTH.SIGNIN_SUBTITLE' | translate }}
  </p>

  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__accent-dark sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'GENERAL.EMAIL_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      type="email"
      formControlName="email"
      [errorStateMatcher]="error_matcher"
      required />
  </mat-form-field>

  <mat-form-field
    class="sp-width__full sp-form-field sp-form-field__accent-dark sp-margin__bottom-x2"
    appearance="fill"
    color="accent">
    <mat-label>
      {{ 'AUTH.PASSWORD_LABEL' | translate }}
    </mat-label>
    <input
      matInput
      [type]="is_password_visible ? 'text' : 'password'"
      formControlName="password"
      [errorStateMatcher]="error_matcher"
      required />
    <mat-icon
      matSuffix
      class="sp-color__accent-contrast sp-cursor__pointer"
      (click)="is_password_visible = !is_password_visible">
      {{ is_password_visible ? 'visibility_off' : 'visibility' }}
    </mat-icon>
  </mat-form-field>
  <h5
    (click)="onPssResetClick()"
    style="margin-top: -8px"
    class="sp-width__full sp-color__accent-contrast sp-text__right sp-text__hover">
    {{ 'AUTH.FORGOT_PSS_CTA' | translate }}
  </h5>

  <app-shared-button
    class="sp-width__full sp-margin__top-x4"
    [button_class]="'sp-button__secondary'"
    [spinner_class]="'sp-spinner__secondary'"
    [cta]="'AUTH.SIGNIN_CTA'"
    [is_disabled]="!isFormValid() || is_signin_running"
    [is_spinner_visible]="is_signin_running"
    (click)="onSigninClick()"></app-shared-button>
</form>
